export class ListaPermissoes {
  ug: string | undefined
  perfis: string[]

  constructor(nomeUg: any) {
    this.ug = nomeUg ?? ''
    this.perfis = []
  }
}